import Reveal from "@/components/base/Reveal";

const VALUES = [
  { icon: "ri-hand-heart-line", label: "Hand-finished" },
  { icon: "ri-plant-line", label: "Natural fibers" },
  { icon: "ri-truck-line", label: "Free over $95" },
  { icon: "ri-recycle-line", label: "Recycled muslin" },
];

export default function Values() {
  return (
    <section className="px-4 md:px-10 lg:px-14 py-12 md:py-16 bg-background-50 border-y border-background-200/70">
      <ul className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
        {VALUES.map((v, i) => (
          <Reveal as="li" key={v.label} from="up" delay={i * 100}>
            <div className="group flex items-center gap-3 md:gap-4 cursor-default">
              <span className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-100 text-foreground-950 group-hover:bg-foreground-950 group-hover:text-background-50 transition-all duration-500 group-hover:rotate-[8deg]">
                <i
                  className={`${v.icon} w-5 h-5 flex items-center justify-center text-lg`}
                />
              </span>
              <span className="font-heading text-base md:text-lg text-foreground-950 whitespace-nowrap">
                {v.label}
              </span>
            </div>
          </Reveal>
        ))}
      </ul>
    </section>
  );
}